module.exports = __webpack_public_path__ + "static/img/poster_2.0235d11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/poster_2.jpg
// module id = 1GlK
// module chunks = 0